import {Component, input} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {RouterLink} from '@angular/router'
import {SIGN_PATH} from '../../general/shared'
import {IProject} from '../../general/types'

@Component({
  selector: 'smt-project-buttons',
  imports: [
    MatButton,
    MatIcon,
    RouterLink
  ],
  templateUrl: './project-buttons.html',
  styleUrl: './project-buttons.scss',
})
export class ProjectButtons {

  public userId = input.required<string>()
  public projects = input.required<IProject[]>()
  protected readonly SIGN_PATH = SIGN_PATH
}
